/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable jsdoc/require-returns */
/* eslint-disable valid-jsdoc */
/* eslint-disable jsdoc/require-param */
import { Series, Points } from '../series/chart-series';
import { findClipRect, RectOption } from '../../common/utils/helper';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
/**
 * `Trendline` module is used to render 6 types of trendlines in chart.
 */
export class Trendlines {
    /**
     * Defines the collection of series, that are used to represent a trendline
     *
     * @private
     */
    initSeriesCollection(trendline, chart) {
        const trendLineSeries = new Series(trendline, 'targetSeries', {}, true);
        if (trendline.type === 'Linear' || trendline.type === 'MovingAverage') {
            trendLineSeries.type = 'Line';
        }
        else {
            trendLineSeries.type = 'Spline';
        }
        this.setSeriesProperties(trendLineSeries, trendline, trendline.type, trendline.fill, trendline.width, chart);
    }
    /**
     * Initializes the properties of the trendline series
     */
    setSeriesProperties(series, trendline, name, fill, width, chart) {
        series.name = trendline.name;
        series.xName = 'x';
        series.yName = 'y';
        series.fill = fill || 'blue';
        series.width = width;
        series.dashArray = trendline.dashArray;
        series.clipRectElement = trendline.clipRectElement;
        series.points = [];
        series.enableTooltip = trendline.enableTooltip;
        series.index = trendline.index;
        series.sourceIndex = trendline.sourceIndex;
        series.interior = series.fill;
        series.animation = trendline.animation;
        series.legendShape = 'HorizontalLine';
        series.marker = trendline.marker;
        series.category = 'TrendLine';
        series.chart = chart;
        series.xMin = Infinity;
        series.xMax = -Infinity;
        series.yMin = Infinity;
        series.yMax = -Infinity;
        series.xData = [];
        series.yData = [];
        trendline.targetSeries = series;
        if (chart.isBlazor) {
            trendline.targetSeries.border = {}; // To avoid console error in blazor
            trendline.targetSeries.connector = {}; // To avoid console error in blazor
        }
    }
    /**
     * Creates the elements of a trendline
     */
    createTrendLineElements(chart, trendline, index, element, clipRectElement) {
        trendline.trendLineElement = element;
        trendline.targetSeries.clipRectElement = clipRectElement;
        trendline.targetSeries.seriesElement = element;
        if (chart.trendLineElements) {
            chart.trendLineElements.appendChild(trendline.trendLineElement);
        }
    }
    /**
     * Defines the data point of trendline
     */
    getDataPoint(x, y, series, index) {
        const trendPoint = new Points();
        trendPoint.x = series.xAxis.valueType === 'DateTime' ? new Date(Number(x)) : x;
        trendPoint.y = y;
        trendPoint.xValue = Number(x);
        trendPoint.color = series.fill;
        trendPoint.index = index;
        trendPoint.yValue = Number(y);
        trendPoint.visible = true;
        series.xMin = Math.min(series.xMin, trendPoint.xValue);
        series.yMin = Math.min(series.yMin, trendPoint.yValue);
        series.xMax = Math.max(series.xMax, trendPoint.xValue);
        series.yMax = Math.max(series.yMax, trendPoint.yValue);
        series.xData.push(trendPoint.xValue);
        return trendPoint;
    }
    /**
     * Finds the slope and intercept of trendline
     */
    findSlopeIntercept(xValues, yValues, trendline, points) {
        let xAvg = 0;
        let yAvg = 0;
        let xyAvg = 0;
        let xxAvg = 0;
        let index = 0;
        let slope = 0;
        let intercept = 0;
        while (index < points.length) {
            // To fix trendline not rendered issue while Nan Value is provided for y values.
            if (isNaN(yValues[index])) {
                yValues[index] = ((yValues[index - 1] + yValues[index + 1]) / 2);
            }
            xAvg += xValues[index];
            yAvg += yValues[index];
            xyAvg += xValues[index] * yValues[index];
            xxAvg += xValues[index] * xValues[index];
            index++;
        }
        const type = trendline.type;
        if (trendline.intercept && (type === 'Linear' || type === 'Exponential')) {
            intercept = trendline.intercept;
            switch (type) {
                case 'Linear':
                    slope = ((xyAvg) - (trendline.intercept * xAvg)) / xxAvg;
                    break;
                case 'Exponential':
                    slope = ((xyAvg) - (Math.log(Math.abs(trendline.intercept)) * xAvg)) / xxAvg;
                    break;
            }
        }
        else {
            slope = ((points.length * xyAvg) - (xAvg * yAvg)) / ((points.length * xxAvg) - (xAvg * xAvg));
            slope = (type === 'Linear' ? slope : Math.abs(slope));
            if (type === 'Exponential' || type === 'Power') {
                intercept = Math.exp((yAvg - (slope * xAvg)) / points.length);
            }
            else {
                intercept = (yAvg - (slope * xAvg)) / points.length;
            }
        }
        return { slope: slope, intercept: intercept };
    }
    /**
     * Defines the points to draw the trendlines.
     */
    initDataSource(trendline) {
        const points = trendline.points;
        if (points && points.length) {
            //prepare data
            const trendlineSeries = trendline.targetSeries;
            switch (trendline.type) {
                case 'Linear':
                    this.setLinearRange(points, trendline, trendlineSeries);
                    break;
                case 'Exponential':
                    this.setExponentialRange(points, trendline, trendlineSeries);
                    break;
                case 'MovingAverage':
                    this.setMovingAverageRange(points, trendline, trendlineSeries);
                    break;
                case 'Polynomial':
                    this.setPolynomialRange(points, trendline, trendlineSeries);
                    break;
                case 'Power':
                    this.setPowerRange(points, trendline, trendlineSeries);
                    break;
                case 'Logarithmic':
                    this.setLogarithmicRange(points, trendline, trendlineSeries);
                    break;
            }
            if (trendline.type !== 'Linear' && trendline.type !== 'MovingAverage') {
                trendlineSeries.chart.splineSeriesModule.findSplinePoint(trendlineSeries);
            }
        }
    }
    /**
     * Calculation of exponential points
     */
    setExponentialRange(points, trendline, series) {
        const xValue = [];
        const yValue = [];
        let index = 0;
        while (index < points.length) {
            const point = points[index];
            const yDataValue = point.yValue ? Math.log(point.yValue) : 0;
            xValue.push(point.xValue);
            yValue.push(yDataValue);
            index++;
        }
        const slopeIntercept = this.findSlopeIntercept(xValue, yValue, trendline, points);
        series.points = this.getExponentialPoints(trendline, points, xValue, yValue, series, slopeIntercept);
    }
    /**
     * Calculation of logarithmic points
     */
    setLogarithmicRange(points, trendline, series) {
        const xLogValue = [];
        const yLogValue = [];
        const xPointsLgr = [];
        let index = 0;
        while (index < points.length) {
            const point = points[index];
            const xDataValue = point.xValue ? Math.log(point.xValue) : 0;
            xPointsLgr.push(point.xValue);
            xLogValue.push(xDataValue);
            yLogValue.push(point.yValue);
            index++;
        }
        const slopeIntercept = this.findSlopeIntercept(xLogValue, yLogValue, trendline, points);
        series.points = this.getLogarithmicPoints(trendline, points, xPointsLgr, yLogValue, series, slopeIntercept);
    }
    /**
     * Calculation of polynomial points
     */
    setPolynomialRange(points, trendline, series) {
        const xPolyValues = [];
        const yPolyValues = [];
        let index = 0;
        while (index < points.length) {
            const point = points[index];
            xPolyValues.push(point.xValue);
            yPolyValues.push(point.yValue);
            index++;
        }
        series.points = this.getPolynomialPoints(trendline, points, xPolyValues, yPolyValues, series);
    }
    /**
     * Calculation of power points
     */
    setPowerRange(points, trendline, series) {
        const xValues = [];
        const yValues = [];
        const powerPoints = [];
        let index = 0;
        while (index < points.length) {
            const point = points[index];
            const xDataValue = point.xValue ? Math.log(point.xValue) : 0;
            const yDataValue = point.yValue ? Math.log(point.yValue) : 0;
            powerPoints.push(point.xValue);
            xValues.push(xDataValue);
            yValues.push(yDataValue);
            index++;
        }
        const slopeIntercept = this.findSlopeIntercept(xValues, yValues, trendline, points);
        series.points = this.getPowerPoints(trendline, points, powerPoints, yValues, series, slopeIntercept);
    }
    /**
     * Calculation of linear points
     */
    setLinearRange(points, trendline, series) {
        const xValues = [];
        const yValues = [];
        let index = 0;
        while (index < points.length) {
            const point = points[index];
            xValues.push(point.xValue);
            yValues.push(point.yValue);
            index++;
        }
        const slopeIntercept = this.findSlopeIntercept(xValues, yValues, trendline, points);
        series.points = this.getLinearPoints(trendline, points, xValues, yValues, series, slopeIntercept);
    }
    /**
     * Calculation of moving average points
     */
    setMovingAverageRange(points, trendline, series) {
        const xValues = [];
        const yValues = [];
        const xAvgValues = [];
        let index = 0;
        while (index < points.length) {
            const point = points[index];
            xAvgValues.push(point.xValue);
            xValues.push(index + 1);
            yValues.push(point.yValue);
            index++;
        }
        series.points = this.getMovingAveragePoints(trendline, points, xAvgValues, yValues, series);
    }
    /**
     * Calculation of logarithmic points
     */
    getLogarithmicPoints(trendline, points, xValues, yValues, series, slopeInterceptLog) {
        const midPoint = Math.round((points.length / 2));
        const pts = [];
        const x1Log = xValues[0] - trendline.backwardForecast;
        const x1 = x1Log ? Math.log(x1Log) : 0;
        const y1Log = slopeInterceptLog.intercept + (slopeInterceptLog.slope * x1);
        const x2Log = xValues[midPoint - 1];
        const x2 = x2Log ? Math.log(x2Log) : 0;
        const y2Log = slopeInterceptLog.intercept + (slopeInterceptLog.slope * x2);
        const x3Log = xValues[xValues.length - 1] + trendline.forwardForecast;
        const x3 = x3Log ? Math.log(x3Log) : 0;
        const y3Log = slopeInterceptLog.intercept + (slopeInterceptLog.slope * x3);
        pts.push(this.getDataPoint(x1Log, y1Log, series, pts.length));
        pts.push(this.getDataPoint(x2Log, y2Log, series, pts.length));
        pts.push(this.getDataPoint(x3Log, y3Log, series, pts.length));
        return pts;
    }
    /**
     * Defines the points based on data point
     */
    getPowerPoints(trendline, points, xValues, yValues, series, slopeInterceptPower) {
        const midPoint = Math.round((points.length / 2));
        const pts = [];
        let x1 = xValues[0] - trendline.backwardForecast;
        x1 = x1 > -1 ? x1 : 0;
        const y1 = slopeInterceptPower.intercept * Math.pow(x1, slopeInterceptPower.slope);
        const x2 = xValues[midPoint - 1];
        const y2 = slopeInterceptPower.intercept * Math.pow(x2, slopeInterceptPower.slope);
        const x3 = xValues[xValues.length - 1] + trendline.forwardForecast;
        const y3 = slopeInterceptPower.intercept * Math.pow(x3, slopeInterceptPower.slope);
        pts.push(this.getDataPoint(x1, y1, series, pts.length));
        pts.push(this.getDataPoint(x2, y2, series, pts.length));
        pts.push(this.getDataPoint(x3, y3, series, pts.length));
        return pts;
    }
    /**
     * Get the polynomial points based on polynomial slopes
     */
    getPolynomialPoints(trendline, points, xValues, yValues, series) {
        let pts = [];
        let polynomialOrder = points.length <= trendline.polynomialOrder ? points.length : trendline.polynomialOrder;
        polynomialOrder = Math.max(2, polynomialOrder);
        polynomialOrder = Math.min(6, polynomialOrder);
        trendline.polynomialOrder = polynomialOrder;
        trendline.polynomialSlopes = [];
        trendline.polynomialSlopes.length = trendline.polynomialOrder + 1;
        let index = 0;
        while (index < xValues.length) {
            const xVal = xValues[index];
            const yVal = yValues[index];
            let subIndex = 0;
            while (subIndex <= trendline.polynomialOrder) {
                if (!trendline.polynomialSlopes[subIndex]) {
                    trendline.polynomialSlopes[subIndex] = 0;
                }
                trendline.polynomialSlopes[subIndex] += Math.pow(xVal, subIndex) * yVal;
                ++subIndex;
            }
            index++;
        }
        const numArray = [];
        numArray.length = 1 + 2 * trendline.polynomialOrder;
        const matrix = [];
        matrix.length = trendline.polynomialOrder + 1;
        let newIndex = 0;
        while (newIndex < (trendline.polynomialOrder + 1)) {
            matrix[newIndex] = [];
            matrix[newIndex].length = 3;
            newIndex++;
        }
        let nIndex = 0;
        while (nIndex < xValues.length) {
            const d = xValues[nIndex];
            let num2 = 1.0;
            let nIndex2 = 0;
            while (nIndex2 < numArray.length) {
                if (!numArray[nIndex2]) {
                    numArray[nIndex2] = 0;
                }
                numArray[nIndex2] += num2;
                num2 *= d;
                ++nIndex2;
            }
            ++nIndex;
        }
        let nnIndex = 0;
        while (nnIndex <= trendline.polynomialOrder) {
            let nnIndex2 = 0;
            while (nnIndex2 <= trendline.polynomialOrder) {
                matrix[nnIndex][nnIndex2] = numArray[nnIndex + nnIndex2];
                ++nnIndex2;
            }
            ++nnIndex;
        }
        if (!this.gaussJordanElimination(matrix, trendline.polynomialSlopes)) {
            trendline.polynomialSlopes = null;
        }
        pts = this.getPoints(trendline, points, xValues, series);
        return pts;
    }
    /**
     * Defines the moving average points
     */
    getMovingAveragePoints(trendline, points, xValues, yValues, series) {
        const pts = [];
        let period = trendline.period >= points.length ? points.length - 1 : trendline.period;
        period = Math.max(2, period);
        let index = 0;
        let y;
        let x;
        let count;
        let nullCount;
        while (index < points.length - 1) {
            y = count = nullCount = 0;
            for (let j = index; count < period; j++) {
                count++;
                y += yValues[j];
            }
            y = period - nullCount < 0 ? null : y ? y / (period - nullCount) : y;
            if (!isNullOrUndefined(y) && !isNaN(y)) {
                x = xValues[period - 1 + index];
                pts.push(this.getDataPoint(x, y, series, pts.length));
            }
            index++;
        }
        return pts;
    }
    /**
     * Defines the linear points
     */
    getLinearPoints(trendline, points, xValues, yValues, series, slopeInterceptLinear) {
        const pts = [];
        const max = xValues.indexOf(Math.max.apply(null, xValues));
        const min = xValues.indexOf(Math.min.apply(null, xValues));
        const x1Linear = xValues[min] - trendline.backwardForecast;
        const y1Linear = slopeInterceptLinear.slope * x1Linear + slopeInterceptLinear.intercept;
        const x2Linear = xValues[max] + trendline.forwardForecast;
        const y2Linear = slopeInterceptLinear.slope * x2Linear + slopeInterceptLinear.intercept;
        pts.push(this.getDataPoint(x1Linear, y1Linear, series, pts.length));
        pts.push(this.getDataPoint(x2Linear, y2Linear, series, pts.length));
        return pts;
    }
    /**
     * Defines the exponential points
     */
    getExponentialPoints(trendline, points, xValues, yValues, series, slopeInterceptExp) {
        const midPoint = Math.round((points.length / 2));
        const ptsExp = [];
        const x1 = xValues[0] - trendline.backwardForecast;
        const y1 = slopeInterceptExp.intercept * Math.exp(slopeInterceptExp.slope * x1);
        const x2 = xValues[midPoint - 1];
        const y2 = slopeInterceptExp.intercept * Math.exp(slopeInterceptExp.slope * x2);
        const x3 = xValues[xValues.length - 1] + trendline.forwardForecast;
        const y3 = slopeInterceptExp.intercept * Math.exp(slopeInterceptExp.slope * x3);
        ptsExp.push(this.getDataPoint(x1, y1, series, ptsExp.length));
        ptsExp.push(this.getDataPoint(x2, y2, series, ptsExp.length));
        ptsExp.push(this.getDataPoint(x3, y3, series, ptsExp.length));
        return ptsExp;
    }
    /**
     * Defines the points based on data point
     */
    getPoints(trendline, points, xValues, series) {
        const polynomialSlopes = trendline.polynomialSlopes;
        const pts = [];
        let x1 = 1;
        let index = 1;
        let xValue;
        let yValue;
        // We have to sort the points in ascending order. Because, the data source of the series may be random order.
        points.sort((a, b) => { return a.xValue - b.xValue; });
        xValues.sort((a, b) => { return a - b; });
        while (index <= polynomialSlopes.length) {
            if (index === 1) {
                xValue = xValues[0] - trendline.backwardForecast;
                yValue = this.getPolynomialYValue(polynomialSlopes, xValue);
                pts.push(this.getDataPoint(xValue, yValue, series, pts.length));
            }
            else if (index === polynomialSlopes.length) {
                xValue = xValues[points.length - 1] + trendline.forwardForecast;
                yValue = this.getPolynomialYValue(polynomialSlopes, xValue);
                pts.push(this.getDataPoint(xValue, yValue, series, pts.length));
            }
            else {
                x1 += (points.length + trendline.forwardForecast) / polynomialSlopes.length;
                xValue = xValues[parseInt(x1.toString(), 10) - 1];
                yValue = this.getPolynomialYValue(polynomialSlopes, xValue);
                pts.push(this.getDataPoint(xValue, yValue, series, pts.length));
            }
            index++;
        }
        return pts;
    }
    /**
     * Defines the polynomial value of y
     */
    getPolynomialYValue(slopes, x) {
        let sum = 0;
        let index = 0;
        while (index < slopes.length) {
            sum += slopes[index] * Math.pow(x, index);
            index++;
        }
        return sum;
    }
    /**
     * Defines the gauss jordan elimination
     */
    gaussJordanElimination(matrix, polynomialSlopes) {
        const length = matrix.length;
        const numArray1 = [];
        const numArray2 = [];
        const numArray3 = [];
        numArray1.length = length;
        numArray2.length = length;
        numArray3.length = length;
        let index = 0;
        while (index < length) {
            numArray3[index] = 0;
            ++index;
        }
        let index1 = 0;
        while (index1 < length) {
            let num1 = 0;
            let index2 = 0;
            let index3 = 0;
            let index4 = 0;
            while (index4 < length) {
                if (numArray3[index4] !== 1) {
                    let index5 = 0;
                    while (index5 < length) {
                        if (numArray3[index5] === 0 && Math.abs(matrix[index4][index5]) >= num1) {
                            num1 = Math.abs(matrix[index4][index5]);
                            index2 = index4;
                            index3 = index5;
                        }
                        ++index5;
                    }
                }
                ++index4;
            }
            ++numArray3[index3];
            if (index2 !== index3) {
                let index4 = 0;
                while (index4 < length) {
                    const num2 = matrix[index2][index4];
                    matrix[index2][index4] = matrix[index3][index4];
                    matrix[index3][index4] = num2;
                    ++index4;
                }
                const num3 = polynomialSlopes[index2];
                polynomialSlopes[index2] = polynomialSlopes[index3];
                polynomialSlopes[index3] = num3;
            }
            numArray2[index1] = index2;
            numArray1[index1] = index3;
            if (matrix[index3][index3] === 0.0) {
                return false;
            }
            const num4 = 1.0 / matrix[index3][index3];
            matrix[index3][index3] = 1.0;
            let iindex4 = 0;
            while (iindex4 < length) {
                matrix[index3][iindex4] *= num4;
                ++iindex4;
            }
            polynomialSlopes[index3] *= num4;
            let iandex4 = 0;
            while (iandex4 < length) {
                if (iandex4 !== index3) {
                    const num2 = matrix[iandex4][index3];
                    matrix[iandex4][index3] = 0.0;
                    let index5 = 0;
                    while (index5 < length) {
                        matrix[iandex4][index5] -= matrix[index3][index5] * num2;
                        ++index5;
                    }
                    polynomialSlopes[iandex4] -= polynomialSlopes[index3] * num2;
                }
                ++iandex4;
            }
            ++index1;
        }
        let iindex1 = length - 1;
        while (iindex1 >= 0) {
            if (numArray2[iindex1] !== numArray1[iindex1]) {
                let iindex2 = 0;
                while (iindex2 < length) {
                    const num = matrix[iindex2][numArray2[iindex1]];
                    matrix[iindex2][numArray2[iindex1]] = matrix[iindex2][numArray1[iindex1]];
                    matrix[iindex2][numArray1[iindex1]] = num;
                    ++iindex2;
                }
            }
            --iindex1;
        }
        return true;
    }
    /**
     * Defines the trendline elements.
     */
    getTrendLineElements(series, chart) {
        findClipRect(series);
        const clipRect = series.clipRect;
        const clipRectElement = chart.renderer.drawClipPath(new RectOption(chart.element.id + '_ChartTrendlineClipRect_' + series.index, 'transparent', { width: 1, color: 'Gray' }, 1, {
            x: 0, y: 0, width: clipRect.width,
            height: clipRect.height
        }));
        const element = chart.renderer.createGroup({
            'id': chart.element.id + 'TrendlineSeriesGroup' + series.index,
            'transform': 'translate(' + clipRect.x + ',' + clipRect.y + ')',
            'clip-path': 'url(#' + chart.element.id + '_ChartTrendlineClipRect_' + series.index + ')'
        });
        //defines the clip rect element
        if (element) {
            element.appendChild(clipRectElement);
        }
        for (const trendline of series.trendlines) {
            this.createTrendLineElements(chart, trendline, trendline.index, element, clipRectElement);
        }
    }
    /**
     * To destroy the trendline.
     */
    destroy() {
        /**
         * Destroys the Linear Trendline
         */
    }
    /**
     * Get module name
     */
    getModuleName() {
        /**
         * Returns the module name of the series
         */
        return 'TrendLine';
    }
}
